/* eslint-disable react-hooks/exhaustive-deps */
import { Button, ButtonGroup, Drawer, Intent, Position } from "@blueprintjs/core"
import { useEffect, useState } from "react"
import { ID } from "src/libs/interfaces/layouts"
import FieldInput, { SCALAR_TYPES } from "src/libs/scalars"
import { __ } from "src/libs/utilities"
import { useSyncState } from "src/modules/pe-basic-module/hooks/useSyncState"
import { HISTORY_TYPE, IHistoryStep, ILanding, SELECT_TYPE } from "src/modules/pe-landing-module/data/interfaces"
import { IHoverElement, ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import PresetLibraryList from "src/modules/pe-landing-module/widgets/composite/PresetLibraryList"
import updateHistory from "../utils/updateHistory"
import { singleChange } from "./singleChange" 
import { ScalableDialog, showToast } from "src/libs/useful"
import globalChange from "./globalChange"
import _clearIcon from "../../../../assets/img/clear.svg"

/* Protopia Ecosystem component */
export interface IMakeupDrawerProps {

}
const MakeupDrawer = (props: IMakeupDrawerProps): JSX.Element => {
    const isMakeupDrawerOpen                        = useLandingStore( (state:ILandingStore) => state.isMakeupDrawerOpen )
    const makeupType                                = useLandingStore( (state:ILandingStore) => state.makeupType ) 
    const [isConfirm, setIsConfirm]                 = useState<boolean>(false)
    const [isClearOpen, setIsClearOpen]             = useState<boolean>(false)
    const [preset, setPreset]                       = useState<any>({})
    const [isGlobal, setIsGlobal]                   = useState<boolean>(false)
    const [isClearGlobal, setIsClearGlobal]         = useState<boolean>(false)
    const curHoverElement = useSyncState<IHoverElement | undefined>( useLandingStore.getState().hoverElement )    
         
    useEffect(() => {
        const unsubscribe = useLandingStore.subscribe(
            ( state: ILandingStore ) => state.hoverElement,
            ( hoverElement:IHoverElement | undefined ) => { 
                if(!!hoverElement) {              
                    curHoverElement.set( hoverElement )          
                }
            }
        )
        return () => unsubscribe()
    }, []) 
    
    const onClose = () => {
        useLandingStore.setState({ isMakeupDrawerOpen: false })
    }
    const onGlobal = (value: any) => {
        setIsGlobal(value !== "isLocal") 
    }
    const onClearGlobal = (value: any) => {
        setIsClearGlobal(value !== "isLocal") 
    }
    const onChoosePreset = ( id: ID, _preset: any ) => {
        setPreset( _preset )
        setIsConfirm( true )
    }
    const onUpdate = () => { 
        if( isGlobal) {
            globalChange(
                makeupType,
                curHoverElement.get(),
                preset
            )
        }
        else {
            singleChange(
                makeupType,
                preset,
                "", 
                curHoverElement.get()?.sectionId,  
            )
        } 
        setIsConfirm( false )
    }
    const onClear = () => {
        if(isClearGlobal) {
             globalChange(
                makeupType,
                curHoverElement.get(),
                {}
            )
        }
        else {
            singleChange(
                makeupType,
                {},
                "", 
                curHoverElement.get()?.sectionId,  
            )
        }
        showToast({
            message: __(isClearGlobal ? "All makeup of this element cleared" : "All makeup of all elements by type are cleared")
        })
    }
    const getTitle = (): string => {
        switch( curHoverElement.get()?.selectType ) {
            case SELECT_TYPE.CONTENT:
                const currentLanding: ILanding = useLandingStore.getState().currentLanding
                const section = currentLanding.sections.find(s => s.id === curHoverElement.get()?.sectionId)
                const meat = section?.data.find( meat => meat.id === curHoverElement.get()?.id )
                return meat?.type || SELECT_TYPE.CONTENT
            default:
                return makeupType
        }
    }
    return <Drawer
        position={ Position.RIGHT }
        portalClassName="z-index-110-none"
        isOpen={ !!isMakeupDrawerOpen } 
        size={ 400 } 
        onClose={ onClose }
    >
        <div style={{ backgroundColor: "var(--drop-select-color)", height: "100dvh", display: "flex", flexDirection: "column" }}>
            <div className="bg-plain text-contrast p2 letter-spacing-2 px-3 py-2 border-bottom ">
                {__( "Makeup" )}: {__( getTitle() )}
            </div>
            <div className="w-100 flex-grow-100 w-100 overflow-y-auto pl-2 pr-0 py-2">
                <PresetLibraryList libName={  getTitle() } className={"w-100 h-100"} onChange={onChoosePreset} />
            </div> 
            <div className="py-1 px-2">
                <Button fill intent="danger" size="large" alignText="left" onClick={ () => setIsClearOpen(true) }>
                    <div className="align-items-center">
                        <img src={_clearIcon} height={20} alt="" className="image-invert mr-3" />
                        {__("Clear all makeup")}
                    </div> 
                </Button>
            </div>
        </div>
        <ScalableDialog  
            isOpen={ isConfirm }
            onClose={ () => setIsConfirm(false) } 
        >
            <div className="p-4">
                <div className="lead">
                    {__( "Select assignment option" ) }:
                </div>
                <div className="strob01" />
                <FieldInput
                    value={ isGlobal ? "isGlobal" : "isLocal" }
                    values={[
                        {
                            _id: "isGlobal",
                            title: "Global all page"
                        },
                        {
                            _id: "isLocal",
                            title: "Only this element"
                        },
                        
                    ]}
                    editable
                    onChange={ onGlobal }
                    type={SCALAR_TYPES.RADIO} 
                    notClear
                />
            </div>
            <ButtonGroup fill>
                <Button intent={ Intent.DANGER } size="large" onClick={ () => setIsConfirm(false) } data-testid="no-button">
                    {__( "Cancel" )}
                </Button> 
                <Button intent={ Intent.SUCCESS } size="large" onClick={ onUpdate } data-testid="yes-button">
                    { __( "Update" ) }
                </Button> 
            </ButtonGroup>
        </ScalableDialog>
        <ScalableDialog  
            isOpen={ isClearOpen }
            onClose={ () => setIsClearOpen(false) } 
        >
            <div className="p-4">
                <div className="lead">
                    {__( "Clear all makeup" ) }:
                </div>
                <div className="strob01" />
                <FieldInput
                    value={ isClearGlobal ? "isGlobal" : "isLocal" }
                    values={[
                        {
                            _id: "isGlobal",
                            title: "Global all thees elements"
                        },
                        {
                            _id: "isLocal",
                            title: "Only this element"
                        },
                        
                    ]}
                    editable
                    onChange={ onClearGlobal }
                    type={SCALAR_TYPES.RADIO} 
                    notClear
                />
            </div>
            <ButtonGroup fill>
                <Button intent={ Intent.DANGER } size="large" onClick={ () => setIsClearOpen(false) } data-testid="no-button">
                    {__( "Cancel" )}
                </Button> 
                <Button intent={ Intent.SUCCESS } size="large" onClick={ onClear } data-testid="yes-button">
                    { __( "Update" ) }
                </Button> 
            </ButtonGroup>
        </ScalableDialog>
    </Drawer>
}
export default MakeupDrawer